import Typography from '@/components/shared/typography/typography.component';
import React from 'react';

const CarDetailsSectionSeparator = () => {
    return (
        <Typography
            variant="captionMedium"
            className="text-gray-600 flex items-center mx-1"
        >
            •
        </Typography>
    );
};

export default CarDetailsSectionSeparator;
